export class ActivityModelFull {
  id: string;
  specifics?: string;

  constructor() {
    this.id = '';
  }
}
